import React from 'react';
import GovLetterPage, { fleetCarRows } from './GovLetterPage';

const PAGE = {
    storageKey: 'YELO_VEHICLE_EXPORT_DATA',
    title: 'Vehicle Export',
    detailsTitle: 'Export Details',
    form: {
        destination: 'سلطنة عمان',
        toAddress: 'السادة هيئة الطرق والمواصلات دبي',
        introStatic: 'نحن شركة الوفاق السعودية لتأجير السيارات ذ.م.م رخصة تجارية رقم: 559385، لا مانع لدينا من تًصدير المركبة المدرج أوصافها أدناه إلى ',
        introDynamic: 'سلطنة عمان (مسقط) لصالح شركة الوفاق لحلول النقل ش ش و، رقم السجل 1598962',
        shippingNote: 'ملاحظة الشحن عن طريق سدرة للنقل وتأجير السيارات ش.ذ.م.م رخصة رقم: 680239'
    },
    fields: [
        { key: 'date', label: 'Export Date', rtl: false },
        { key: 'destination', label: 'Export Title Destination' },
        {
            key: 'introDynamic',
            label: 'Intro Details (Destination/Client)',
            help: <span dir="rtl" className="block text-right">نص الشركة والترخيص سيتم إضافته تلقائياً في البداية</span>,
            full: true,
            rows: 3,
        },
        { key: 'shippingNote', label: 'Shipping Note', full: true },
    ],
    pdfName: 'Vehicle_Export_',
    pageId: 'export-page-',
    showYear: true,
    letter: {
        heading: (f) => <>تصدير مركبة إلى {f.destination}</>,
        noCity: true,
        intro: (f) => <>{f.introStatic} {f.introDynamic}</>,
        rows: fleetCarRows,
        afterTable: (f) => (
            <div dir="rtl" style={{ fontSize: '12pt', fontWeight: 'bold', marginBottom: '15mm', whiteSpace: 'pre-wrap' }}>
                {f.shippingNote}
            </div>
        ),
        footerGap: '20mm',
    },
};

const VehicleExport = (props) => <GovLetterPage page={PAGE} {...props} />;

export default VehicleExport;
